import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { sendEmail } from "../services/contact.service.ts";
import { toast } from 'react-toastify';

// Clinic location: Korang Town, Islamabad (OpenStreetMap embed - no API key)
const MAP_EMBED_URL =
  "https://www.openstreetmap.org/export/embed.html?bbox=73.12%2C33.56%2C73.15%2C33.60&layer=mapnik&marker=33.5794%2C73.1372";


const Contact = () => {
  const formik = useFormik({
    initialValues: {
      to: ['jamshaid002@outlook.com'],
      cc: [],
      bcc: [],
      senderName: "",
      senderEmail: "",
      subject: "",
      body: "",
      isHtml: false,
    },

    validationSchema: Yup.object({
      senderName: Yup.string().required("Name is Required"),
      senderEmail: Yup.string()
        .email("Invalid Email Address")
        .required("Emails is required"),
      body: Yup.string()
        .min(15, "Message must be atleast 15 characters long")
        .required("Message is required"),
    }),
    onSubmit: async (values) => {
      try {
        await sendEmail(values);

        toast.success("Thank you for contacting us. We will get back to you soon.");
        formik.resetForm();
      } catch (e) {
        console.error("Error sending email: ", e);
      }
    },
  });
  return (
    <div>
      <section
        className="page-title-section overlay"
        style={{ backgroundImage: "url(images/backgrounds/page-title.jpg)" }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-8">
              <ul className="list-inline custom-breadcrumb mb-2">
                <li className="list-inline-item text-white h3 font-secondary">
                  Contact Us
                </li>
              </ul>
              <p className="text-lighten mb-0">
                Call -03345447745 to make inquiries about available slots and other details
              </p>
            </div>
          </div>
        </div>
      </section>
      <section className="section bg-gray">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <h2 className="section-title">Contact Us</h2>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-7 mb-4 mb-lg-0">
              <form onSubmit={formik.handleSubmit}>
                <div>
                  <input
                    type="text"
                    className="form-control mb-3"
                    id="senderName"
                    name="senderName"
                    value={formik.values.senderName}
                    onBlur={formik.handleBlur}
                    onChange={formik.handleChange}
                    placeholder="Your Name"
                    required
                  />
                  <span className="ml-4">
                    {formik.touched.senderName && formik.errors.senderName
                      ? formik.errors.senderName
                      : ""}
                  </span>
                </div>

                <div>
                  <input
                    type="email"
                    className="form-control mb-3"
                    id="senderEmail"
                    name="senderEmail"
                    value={formik.values.senderEmail}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Your Email"
                    required
                  />
                  <span className="ml-4">
                    {formik.touched.senderEmail && formik.errors.senderEmail
                      ? formik.errors.senderEmail
                      : ""}
                  </span>
                </div>

                <div>
                  <input
                    type="text"
                    className="form-control mb-3"
                    id="subject"
                    name="subject"
                    value={formik.values.subject}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    placeholder="Subject"
                  />
                  <span className="ml-4">
                    {formik.touched.subject && formik.errors.subject
                      ? formik.errors.subject
                      : ""}
                  </span>
                </div>

                <div>
                  <textarea
                    name="body"
                    id="body"
                    className="form-control mb-3"
                    placeholder="Your Message"
                    value={formik.values.body}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    required
                  ></textarea>
                  <span className="ml-4">
                    {formik.touched.body && formik.errors.body
                      ? formik.errors.body
                      : ""}
                  </span>
                </div>
                <button type="submit" value="send" className="btn btn-primary">
                  SEND MESSAGE
                </button>
              </form>
            </div>
            <div className="col-lg-5">
              <h4 className="mb-3">🕒 Clinic Hours</h4>
              <p className="mb-4">
                2:30 PM – 6:00 PM<br />
                Monday to Sunday<br />
                <small className="text-muted">(Appointments must be booked one day in advance)</small>
              </p>
              <h4 className="mb-3">📍 Clinic Address</h4>
              <p className="mb-4">
                The Speech Clinic by Jamshaid Haider Malik<br />
                House Number 3, Street 58,<br />
                Korang Town, Korang Housing Society,<br />
                Islamabad 46000, Pakistan
              </p>
              <h4 className="mb-3">🗺 Google Maps</h4>
              <a
                href="https://maps.app.goo.gl/hUFpafrPK64pF1dy5"
                target="_blank"
                rel="noopener noreferrer"
                className="mb-4 text-color h5 d-block"
              >
                👉 Get directions
              </a>
              <a href="tel:+923345447745" className="text-color h5 d-block">
                📞 0334-544-7745
              </a>
              <a
                href="mailto:thespeechclinicrwp@gmail.com"
                className="mb-5 text-color h5 d-block"
              >
                thespeechclinicrwp@gmail.com
              </a>
            </div>
          </div>
        </div>
      </section>

      <section>
        <div id="map_canvas" style={{ height: "500px", width: "100%", minHeight: "400px" }}>
          <iframe
            title="Clinic location - The Speech Clinic, Korang Town, Islamabad"
            src={MAP_EMBED_URL}
            width="100%"
            height="100%"
            style={{ border: 0 }}
            allowFullScreen
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </section>
    </div>
  );
};

export default Contact;
